import {
    ToastConfirmIntentErrorEvent,
    ToastConfirmIntentResultEvent,
    ToastConfirmIntentResultEventContent,
} from "src/features/paymentGateways/pos/toast/types";

export const confirmToastIntent = () =>
    new Promise<ToastConfirmIntentResultEventContent>((resolve, reject) => {
        (window as any).Toast.confirmIntent(
            (e: ToastConfirmIntentResultEvent) => resolve(e.content),
            (e: ToastConfirmIntentErrorEvent) => {
                reject(new Error(e.cause?.message ?? "Failed to confirm intent"));
            }
        );
    });
